<template>
  <t-layout>
    <login-main @loginSuccess="loginSuccessHandler" />
  </t-layout>
</template>

<script>
import loginMain from './main'

export default {
  name: 'loginView',
  components: {
    loginMain
  },
  methods: {
    loginSuccessHandler() {
      this.$router.back()
    }
  }
}
</script>
